import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EmiratesModalState {
  documentUploadEmiratesModalOpen: boolean;
}

const initialState: EmiratesModalState = {
  documentUploadEmiratesModalOpen: false,
};

const emiratesModalSlice = createSlice({
  name: 'emiratesModal',
  initialState,
  reducers: {
    setDocumentUploadEmiratesModalOpen: (state, action: PayloadAction<boolean>) => {
      state.documentUploadEmiratesModalOpen = action.payload;
    },

    toggleDocumentUploadEmiratesModal: state => {
      state.documentUploadEmiratesModalOpen = !state.documentUploadEmiratesModalOpen;
    },
  },
});

export const { setDocumentUploadEmiratesModalOpen, toggleDocumentUploadEmiratesModal } = emiratesModalSlice.actions;

export default emiratesModalSlice.reducer;
